import _ from 'lodash';
import { determineErrorFromResponse, determineErrorIfStaticRender } from 'helpers/ContentHelper';
import { FETCH_ARTICLE } from './ArticleActions';

const INITIAL_STATE = {
  panels: null,
  seo: null,
  errors: null,
};

export default function(state = INITIAL_STATE, action) {
  let errors = determineErrorFromResponse(action);
  if (errors) {
    return {
      ...state,
      errors,
    };
  }
  const data = _.get(action, 'payload.data', null);
  const panels = _.get(data, 'panels', null);
  const seo = _.get(data, 'SEO', null);
  const article = _.get(panels, 'member.0.items.member.0');
  const articleBody = _.get(article, 'articleBody', null);
  switch (action.type) {
    case FETCH_ARTICLE:
      if (!articleBody) errors = determineErrorIfStaticRender();
      return {
        ...state,
        panels,
        seo,
        errors,
      };
    default:
      return state;
  }
}
